<template>
  <div class="landing-page">
    <!-- Header -->
    <header class="header">
      <div class="header-container">
        <nav class="nav">
          <!-- Logo -->
          <div class="logo">
            <a href="https://intelite.com.br/" target="_blank" rel="noopener noreferrer">
              <img 
                src="@/assets/logoInteliteAzul.png" 
                alt="Intelite Tecnologia" 
                class="logo-image"
              />
            </a>
          </div>

          <!-- Menu Desktop -->
          <div class="nav-desktop">
            <button
              v-for="item in menuItemsVisiveis"
              :key="item.id"
              @click="scrollToSection(item.id)"
              class="nav-button"
              :class="{ 'active': activeSection === item.id }"
            >
              <span 
                class="nav-underline"
                :class="{ 'active': activeSection === item.id }"
              ></span>
              {{ item.label }}
            </button>
          </div>

          <!-- Botão Login Desktop -->
          <div class="login-desktop">
            <button
              @click="goToLogin"
              class="login-button"
            >
              <svg class="login-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
              </svg>
              LOGIN
            </button>
          </div>

          <!-- Menu Mobile Button -->
          <button
            @click="toggleMenu"
            class="menu-toggle"
          >
            <svg
              class="menu-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                v-if="!isMenuOpen"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
              <path
                v-else
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </nav>
      </div>

      <!-- Overlay escuro -->
      <div v-if="isMenuOpen" class="overlay" @click="toggleMenu"></div>

      <!-- Menu Mobile -->
      <div
        class="nav-mobile"
        :class="{ 'open': isMenuOpen }"
      >
        <div class="nav-mobile-content">
          <button
            v-for="item in menuItems"
            :key="item.id"
            @click="scrollToSection(item.id)"
            class="nav-button-mobile"
            :class="{ 'active': activeSection === item.id }"
          >
            {{ item.label }}
          </button>
          
          <!-- Botão Login Mobile -->
          <button
            @click="goToLogin"
            class="login-button"
          >
            <svg class="login-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
            </svg>
            LOGIN
          </button>
        </div>
      </div>
    </header>

     <!-- Hero Section -->
      <section id="home" class="hero-section">
       <div class="hero-banner-container">
         <img src="../assets/avalizeinterna.png" alt="Hero Background" class="hero-background">
         <div class="hero-content">
           <div class="hero-left">
             <img src="../assets/avalizequest.png" alt="Avalize Quest" class="hero-quest-image">
           </div>
           <div class="hero-right">
             <h1 class="hero-text">
               <span class="text-line">Atendimento</span>
               <span class="text-line text-line-highlight">mais ágil e</span>
               <span class="text-line">organizado</span>
             </h1>
           </div>
         </div>
              </div>
      </section>

    <!-- About Section -->
    <section id="sobre" class="about-section">
      <div class="container">
        <div class="about-content">
           <div class="about-image">
              <img src="../assets/mulheravalize.png" alt="Mulher Avalize" class="about-main-image">
           </div>
           <div class="about-text">
             <h2 class="section-title">Sobre o Avalize</h2>
                <div class="about-text-content">
                  <p class="section-description">
                    O Avalize é uma solução completa, ideal para medir a satisfação do cliente através do sistema NPS (Net Promoter Score) e aprimorar a experiência de atendimento no dia a dia. Com relatórios detalhados que ajudam a identificar pontos fortes e áreas de melhoria, feedback em tempo real e gestão de satisfação em tempo real, a solução proporciona uma visão clara e objetiva sobre a experiência do atendimento, ajustando-se de maneira flexível às demandas específicas de diversos setores, garantindo eficiência e elevação dos padrões de atendimento.
                  </p>
                </div>
              </div>
              </div>
      </div>
      </section>

    <!-- Advantages Section -->
    <section id="vantagens" class="advantages-section">
      <div class="container">
        <div class="advantages-content">
           <div class="advantages-image">
             <img src="../assets/vantagensavalize.png" alt="Vantagens" class="advantages-img">
              </div>
          <div class="advantages-text">
            <div class="advantages-text-content">
              <div class="advantages-list">
                 <div class="advantage-item">
                   <img src="../assets/iconecheckboxavalize.png" alt="Customização completa" class="check-icon">
                   <span class="advantage-text">Customização completa</span>
                 </div>
                 <div class="advantage-item">
                   <img src="../assets/iconecheckboxavalize.png" alt="Venda assistida" class="check-icon">
                   <span class="advantage-text">Venda assistida</span>
                 </div>
                 <div class="advantage-item">
                   <img src="../assets/iconecheckboxavalize.png" alt="Relatórios Detalhados" class="check-icon">
                   <span class="advantage-text">Relatórios Detalhados</span>
                 </div>
                 <div class="advantage-item">
                   <img src="../assets/iconecheckboxavalize.png" alt="DASHBOARD NPS" class="check-icon">
                   <span class="advantage-text">DASHBOARD NPS</span>
                 </div>
                 <div class="advantage-item">
                   <img src="../assets/iconecheckboxavalize.png" alt="Classificação detalhada de DETRATORES" class="check-icon">
                   <span class="advantage-text">Classificação detalhada de DETRATORES</span>
                 </div>
                 <div class="advantage-item">
                   <img src="../assets/iconecheckboxavalize.png" alt="Múltiplos canais de envio" class="check-icon">
                   <span class="advantage-text">Múltiplos canais de envio</span>
                 </div>
                 <div class="advantage-item">
                   <img src="../assets/iconecheckboxavalize.png" alt="Integração com o Atendimento Inteligente" class="check-icon">
                   <span class="advantage-text">Integração com o Atendimento Inteligente</span>
                 </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </section>

    <!-- Pricing Section -->
    <section v-if="mostrarPrecos" id="precos" class="pricing-section">
      <div class="container">
        <div class="pricing-content">
          <h2 class="section-title pricing-title">Planos e valores</h2>
          <p class="section-description pricing-description">
            Tudo que você precisa para medir e melhorar a satisfação dos seus clientes.
          </p>
          <div class="pricing-cards">
            <div class="pricing-card" v-for="item in planos" :key="item.id">
              <span class="pricing-card-nome">{{ item.nome }}</span>
              <div class="pricing-value">
                <span class="pricing-currency">R$</span>
                <span class="pricing-amount">{{ formatarValor(item.valorMensal) }}</span>
                <span class="pricing-period">/mês</span>
              </div>
              <ul class="pricing-features">
                <li>Pesquisas NPS ilimitadas</li>
                <li>Envio por e-mail, SMS, WhatsApp e QR Code</li>
                <li>Dashboard e relatórios em tempo real</li>
              </ul>
              <button @click="goToContratar(item.slug)" class="pricing-cta-button">Contratar agora</button>
            </div>
          </div>
        </div>
      </div>
      </section>

    <!-- Clients Section -->
    <section id="clientes" class="clients-section">
      <div class="container">
        <div class="clients-content">
           <div class="clients-image">
             <img src="../assets/clienteavalize.png" alt="Clientes" class="clients-img">
          </div>
           <div class="clients-text">
             <div class="clients-logos">
               <img src="../assets/sicooblogo.png" alt="Sicoob" class="client-logo">
               <img src="../assets/rooseanelogo.png" alt="Rooseane" class="client-logo">
               <img src="../assets/provisaologo.png" alt="Provisao" class="client-logo">
               <img src="../assets/intenselogo.png" alt="Intense" class="client-logo">
               <img src="../assets/brmusiclogo.png" alt="BR Music" class="client-logo">
               <img src="../assets/endologo.png" alt="Endo" class="client-logo">
               <img src="../assets/hnllogo.png" alt="HNL" class="client-logo">
             </div>
           </div>
        </div>
      </div>
      </section>

    <!-- WhatsApp Button Section -->
    <section id="contato" class="whatsapp-section">
      <div class="container">
        <div class="whatsapp-content">
           <a href="https://wa.me/558335125222" target="_blank" class="whatsapp-button">
            <v-icon color="white" class="whatsapp-icon">mdi-whatsapp</v-icon>
            <span class="whatsapp-text">FALE CONOSCO</span>
          </a>
          </div>
      </div>
      </section>

    <!-- Footer -->
    <footer class="footer">
      <div class="container">
        <!-- Logo Section -->
         <div class="footer-logo-section">
           <a href="https://intelite.com.br/" target="_blank">
             <img src="../assets/logo-branco-orizontal.png" alt="Intelite Tecnologia" class="footer-logo-img">
           </a>
         </div>
        
        <!-- Information Section -->
        <div class="footer-info-section">
          <div class="footer-column">
            <h3 class="footer-column-title">Endereço</h3>
                  <div class="footer-info-item">
              <v-icon color="white" class="footer-icon">location_on</v-icon>
                    <div class="footer-info-text">
                      <div>R. Carteiro Olivio Pontes, 575 - Água Fria</div>
                      <div>João Pessoa - PB, 58053-020</div>
                    </div>
                  </div>
          </div>

          <div class="footer-column">
            <h3 class="footer-column-title">Contato</h3>
                  <div class="footer-info-item">
              <v-icon color="white" class="footer-icon">phone</v-icon>
                    <div class="footer-info-text">(83) 3512-5222</div>
                  </div>
                  <div class="footer-info-item">
              <v-icon color="white" class="footer-icon">email</v-icon>
                    <div class="footer-info-text">comercial@intelite.com.br</div>
                  </div>
          </div>

          <div class="footer-column">
            <h3 class="footer-column-title">Redes Sociais</h3>
                  <div class="footer-social-icons">
                    <a href="https://www.instagram.com/intelite_tecnologia/" target="_blank" class="social-icon">
                <v-icon color="white" class="footer-icon">mdi-instagram</v-icon>
                    </a>
                    <a href="https://www.linkedin.com/company/intelite-tecnologia/" target="_blank" class="social-icon">
                <v-icon color="white" class="footer-icon">mdi-linkedin</v-icon>
                    </a>
                  </div>
          </div>
        </div>
        
        <!-- Separator Line -->
              <div class="footer-separator"></div>

        <!-- Copyright Section -->
              <div class="footer-copyright">
                <p>© 2025 Intelite Tecnologia. Todos os direitos reservados.</p>
              </div>
      </div>
    </footer>

     <!-- WhatsApp Floating Button -->
      <a href="https://wa.me/558335125222" target="_blank" class="whatsapp-floating-button">
        <v-icon color="white" class="whatsapp-floating-icon">mdi-whatsapp</v-icon>
      </a>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl } from '@/global'

export default {
  name: 'LandingPage',
  data() {
    return {
      activeSection: 'home',
      mobileMenuOpen: false,
      isMenuOpen: false,
      isScrolling: false,
      menuItems: [
        { id: 'home', label: 'HOME' },
        { id: 'sobre', label: 'SOBRE' },
        { id: 'vantagens', label: 'VANTAGENS' },
        { id: 'precos', label: 'PREÇOS' },
        { id: 'clientes', label: 'CLIENTES' },
        { id: 'contato', label: 'CONTATO' }
      ],
      planos: [],
      autocontratacaoAtiva: false,
    }
  },
  computed: {
    mostrarPrecos() {
      return this.autocontratacaoAtiva && this.planos.length > 0
    },
    menuItemsVisiveis() {
      return this.menuItems.filter(item => item.id !== 'precos' || this.mostrarPrecos)
    },
  },
  mounted() {
    // Smooth scroll para navegação
    this.setupSmoothScroll()
    // Observar seções para atualizar navegação ativa
    this.setupIntersectionObserver()
    // Observar elementos para animações de entrada
    this.setupScrollAnimations()
    // Carrega config (toggle da auto-contratação) e os planos exibidos na landing
    this.carregarConfiguracao()
    this.carregarPlanos()
  },
  methods: {
    setupSmoothScroll() {
      const links = document.querySelectorAll('.nav-link')
      links.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault()
          const targetId = link.getAttribute('href')
          const targetElement = document.querySelector(targetId)
          if (targetElement) {
            targetElement.scrollIntoView({
              behavior: 'smooth'
            })
            // Atualizar seção ativa
            this.activeSection = targetId.substring(1)
          }
        })
      })
    },
    setupIntersectionObserver() {
      const sections = document.querySelectorAll('section[id]')
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.activeSection = entry.target.id
          }
        })
      }, {
        threshold: 0.3,
        rootMargin: '-100px 0px -100px 0px'
      })

      sections.forEach(section => {
        observer.observe(section)
      })
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },

    goToLogin() {
      this.$router.push('/login')
    },
    goToContratar(slug) {
      this.$router.push('/contratar/' + slug)
    },
    formatarValor(valor) {
      return Number(valor || 0).toFixed(2).replace('.', ',')
    },
    async carregarConfiguracao() {
      await axios.get(baseApiUrl + 'Configuracoes/info')
        .then(response => {
          this.autocontratacaoAtiva = !!(response.data && response.data.autocontratacao === true);
        })
        .catch(() => {
          this.autocontratacaoAtiva = false;
        });
    },
    async carregarPlanos() {
      // Só os planos marcados para exibição na landing e ativos
      const filtro = encodeURIComponent(JSON.stringify({ where: { exibirLanding: true, ativo: true }, order: 'valorMensal ASC' }));
      await axios.get(baseApiUrl + 'Planos?filter=' + filtro)
        .then(response => {
          this.planos = response.data || [];
        })
        .catch(() => {
          this.planos = [];
        });
    },
    scrollToSection(sectionId) {
      // Define imediatamente a seção ativa para evitar piscadas
      this.activeSection = sectionId
      this.isMenuOpen = false
      this.mobileMenuOpen = false
      this.isScrolling = true // Desabilita updateActiveSection durante o scroll
      
      if (sectionId === 'contato') {
        // Para contato, vai para o footer
        const footer = document.querySelector('.footer')
        if (footer) {
          const headerHeight = 80
          const targetPosition = footer.offsetTop - headerHeight
          
          // Scroll suave com animação personalizada
          this.smoothScrollTo(targetPosition)
        }
      } else {
        // Para outras seções, comportamento normal
        const element = document.getElementById(sectionId)
        if (element) {
          const headerHeight = 80
          const targetPosition = element.offsetTop - headerHeight
          
          // Scroll suave com animação personalizada
          this.smoothScrollTo(targetPosition)
        }
      }
    },

    smoothScrollTo(targetPosition) {
      const startPosition = window.pageYOffset
      const distance = targetPosition - startPosition
      const duration = 800 // 800ms
      let start = null

      const animation = (currentTime) => {
        if (start === null) start = currentTime
        const timeElapsed = currentTime - start
        const run = this.easeInOutQuad(timeElapsed, startPosition, distance, duration)
        window.scrollTo(0, run)
        if (timeElapsed < duration) {
          requestAnimationFrame(animation)
        } else {
          // Reabilita updateActiveSection quando terminar o scroll
          this.isScrolling = false
        }
      }

      requestAnimationFrame(animation)
    },

    easeInOutQuad(t, b, c, d) {
      t /= d / 2
      if (t < 1) return c / 2 * t * t + b
      t--
      return -c / 2 * (t * (t - 2) - 1) + b
    },
    setupScrollAnimations() {
      // Elementos que devem ser animados
      const animatedElements = [
        { selector: '.hero-logo', animation: 'fadeInUp' },
        { selector: '.about-img', animation: 'fadeInLeft' },
        { selector: '.section-title', animation: 'fadeInRight' },
        { selector: '.section-description', animation: 'fadeInRight' },
        { selector: '.advantages-img', animation: 'fadeInLeft' },
        { selector: '.advantage-item', animation: 'fadeInUp' },
        { selector: '.clients-img', animation: 'fadeInLeft' },
        { selector: '.client-logo', animation: 'fadeInUp' },
        { selector: '.whatsapp-button', animation: 'bounceInUp' }
      ]

      // Configuração do Intersection Observer
      const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const element = entry.target
            
            // Aplicar animação baseada no tipo de elemento
            if (element.classList.contains('advantage-item')) {
              // Para itens de vantagem, aplicar delay baseado na posição
              const items = document.querySelectorAll('.advantage-item')
              const index = Array.from(items).indexOf(element)
              element.style.animationDelay = `${index * 0.2}s`
              element.classList.add('animate-fadeInUp')
            } else if (element.classList.contains('client-logo')) {
              // Para logos de clientes, aplicar delay baseado na posição
              const logos = document.querySelectorAll('.client-logo')
              const index = Array.from(logos).indexOf(element)
              element.style.animationDelay = `${index * 0.2}s`
              element.classList.add('animate-fadeInUp')
            } else {
              // Para outros elementos, aplicar animação diretamente
              const animationClass = element.dataset.animation || 'fadeInUp'
              element.classList.add(`animate-${animationClass}`)
            }
            
            // Parar de observar o elemento após animação
            observer.unobserve(element)
          }
        })
      }, observerOptions)

      // Observar todos os elementos
      animatedElements.forEach(({ selector, animation }) => {
        const elements = document.querySelectorAll(selector)
        elements.forEach(element => {
          element.dataset.animation = animation
          element.classList.add('animate-ready')
          observer.observe(element)
        })
      })
    }
  }
}
</script>

<style scoped>
.landing-page {
  font-family: 'Roboto', sans-serif;
  line-height: 1.6;
}

/* Header */
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 50;
  height: 86px; 
  border-top: 3px solid #0f0f41;
  transition: all 0.3s ease;
}

@media (max-width: 768px) {
  .header {
    height: 66px;
  }
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media (max-width: 768px) {
  .header-container {
    padding: 15px 16px;
    min-height: 70px;
    display: flex;
    align-items: center;
  }
}

.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.logo {
  width: 160px;
  overflow: visible;
}

.logo a {
  text-decoration: none;
  display: block;
}

.logo-image {
  height: auto;
  width: 100%;
  margin-left: 0;
  transition: opacity 0.3s ease;
}

@media (min-width: 960px) {
  .logo-image {
    margin-left: 0;
    transform: translateX(-30px);
  }
}

@media (min-width: 1440px) {
  .logo-image {
    transform: translateX(-60px);
  }
}

@media (min-width: 1920px) {
  .logo-image {
    transform: translateX(-90px);
  }
}

@media (max-width: 768px) {
  .logo-image {
    margin-left: 0px;
  }
}

.logo a:hover .logo-image {
  opacity: 0.8;
}

.nav-desktop {
  display: flex;
  flex: 1;
  justify-content: center;
  gap: 48px;
}

.login-desktop {
  display: flex;
  align-items: center;
  margin-left: auto;
  height: 100%;
}

.nav-button {
  color: #374151;
  background: none;
  border: none;
  font-weight: 700;
  position: relative;
  padding: 8px 0;
  cursor: pointer;
  transition: color 0.3s ease;
  text-transform: uppercase;
  font-size: 16px;
}

.nav-button:hover {
  color: #111827;
}

.nav-button.active {
  color: #2B3674;
  font-weight: 700;
}

.nav-underline {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #2B3674;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.nav-underline.active {
  transform: scaleX(1);
}

.login-button {
  background: #0F3B39;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-weight: 700;
  font-size: 16px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  min-width: 120px;
}

.login-button:hover {
  background: #0a2d2b;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(15, 59, 57, 0.4);
}

.login-icon {
  width: 16px;
  height: 16px;
}

.menu-toggle {
  display: none;
  background: none;
  border: none;
  color: #374151;
  cursor: pointer;
  margin-left: auto;
  order: 2;
}

.menu-toggle:hover {
  color: #111827;
}

.menu-icon {
  width: 24px;
  height: 24px;
}

@media (max-width: 768px) {
  .menu-icon {
    width: 32px;
    height: 32px;
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 30;
}

.nav-mobile {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  background: white;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  z-index: 40;
  transform: translateY(-100%);
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}

.nav-mobile.open {
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
}

.nav-mobile-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 40px 0;
}

.nav-button-mobile {
  color: #374151;
  background: none;
  border: none;
  font-weight: 700;
  font-size: 20px;
  cursor: pointer;
  transition: color 0.3s ease;
}

.nav-button-mobile:hover {
  color: #111827;
}

.nav-button-mobile.active {
  color: #2B3674;
  font-weight: 700;
}

/* Estilo para o botão de login no mobile (usando a mesma classe) */
.nav-mobile .login-button {
  margin-top: 16px;
}

/* Responsive */
@media (max-width: 768px) {
  .nav-desktop {
    display: none;
  }
  
  .login-desktop {
    display: none;
  }
  
  .menu-toggle {
    display: block;
  }
}


/* Hero Section */
.hero-section {
  width: 100%;
  margin-top: 86px;
}

@media (max-width: 768px) {
  .hero-section {
    margin-top: 66px;
  }
}

.hero-banner-container {
  position: relative;
  width: 100%;
  height: 600px;
  overflow: hidden;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  padding: 0 2%;
  max-width: 1400px;
  margin: 0 auto;
}

.hero-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  flex: 2;
  max-width: 65%;
  margin-left: -50px;
}

.hero-text {
  color: white;
  font-family: 'Poppins Bold', sans-serif;
  font-weight: 900;
  font-size: 3.5rem;
  line-height: 1.1;
  text-align: left !important;
  animation: slideInLeft 1s ease-out;
  width: 100%;
  margin: 0;
  padding: 0;
}

.text-line {
  display: block;
  opacity: 0;
  animation: fadeInUp 0.8s ease-out forwards;
  text-align: left !important;
}

.text-line-highlight {
  color: #14c7b8 !important;
}

.text-line:nth-child(1) { animation-delay: 0.2s; }
.text-line:nth-child(2) { animation-delay: 0.4s; }
.text-line:nth-child(3) { animation-delay: 0.6s; }
.text-line:nth-child(4) { animation-delay: 0.8s; }
.text-line:nth-child(5) { animation-delay: 1s; }

.hero-check-icon {
  width: 40px;
  height: 40px;
  filter: brightness(0) invert(1);
}

.hero-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: 35%;
  margin-left: 0px;
  text-align: left;
  padding-top: 50px;
}

.hero-logo {
  width: 100%;
  max-width: 400px;
  height: auto;
  object-fit: contain;
  animation: fadeInUp 0.8s ease-out;
}

.hero-quest-image {
  width: 100%;
  max-width: none !important;
  height: auto;
  object-fit: contain;
  animation: slideInLeft 1s ease-out;
  min-width: 800px;
  transform: scale(1.2);
}

.hero-cards {
  width: 100%;
  max-width: 500px;
  height: auto;
  object-fit: contain;
  animation: slideInRight 1.2s ease-out;
}

/* About Section */
.about-section {
  padding: 60px 20px 80px 20px;
  background: white;
}

.about-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 100px;
}

.about-image {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0;
  background: transparent;
}

.about-main-image {
  width: 100%;
  max-width: 1400px;
  height: 480px !important;
  object-fit: cover;
  border-radius: 0;
  box-shadow: none;
  background: transparent;
}

.retangulo-molde {
  position: relative;
  max-width: 1300px;
  padding-left: 16px;
  padding-right: 16px;
  margin: 0 auto;
}

.imagem-conteudo {
  background-image: url('../assets/mulheravalize.png');
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  height: 500px;
  width: 100%;
  display: block;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-height: 400px;
}

.about-text {
  text-align: left;
  max-width: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0;
  margin-left: 0;
}

.about-text-content {
  text-align: justify;
  width: 100%;
}

.section-title {
  font-family: 'AlibabaSans', sans-serif;
  font-size: 2rem;
  color: #0F3B39;
  margin-bottom: 30px;
  font-weight: 900;
  text-align: left;
  width: 100%;
}

.section-description {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.1rem;
  color: #090913;
  line-height: 1.8;
  text-indent: 0;
  font-weight: 400;
}

/* Advantages Section */
.advantages-section {
  padding: 60px 0 80px 0;
  background: white;
}

.advantages-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.advantages-image {
  width: 100%;
  display: flex;
  justify-content: center;
}

.advantages-img {
  width: 80%;
  height: auto;
  max-width: 800px;
}

.advantages-text {
  text-align: left;
  max-width: 80%;
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0;
  margin-top: 20px;
  margin-left: 0;
}

.advantages-text-content {
  text-align: justify;
  width: 100%;
}

.advantages-list {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.advantage-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 5px 0;
}

.check-icon {
  font-size: 24px !important;
  min-width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  }

.advantage-text {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.2rem;
  color: #090913;
  font-weight: 500;
}

/* Pricing Section */
.pricing-section {
  padding: 60px 0 80px 0;
  background: #f4f6f6;
}

.pricing-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
}

.pricing-title {
  text-align: center;
  width: auto;
}

.pricing-description {
  text-align: center;
  max-width: 600px;
  margin-bottom: 32px;
}

.pricing-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 24px;
  width: 100%;
}

.pricing-card {
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 16px;
  border: 1px solid #0F3B39;
  padding: 40px 48px;
  box-shadow: 0 10px 30px rgba(15, 59, 57, 0.08);
  max-width: 380px;
  width: 100%;
}

.pricing-card-nome {
  font-family: 'AlibabaSans', sans-serif;
  font-size: 1.3rem;
  font-weight: 900;
  color: #0F3B39;
  margin-bottom: 16px;
}

.pricing-value {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
  margin-bottom: 24px;
}

.pricing-currency {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.4rem;
  font-weight: 700;
  color: #0F3B39;
}

.pricing-amount {
  font-family: 'AlibabaSans', sans-serif;
  font-size: 3rem;
  font-weight: 900;
  color: #0F3B39;
}

.pricing-period {
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  color: #6b7676;
}

.pricing-features {
  list-style: none;
  padding: 0;
  margin: 0 0 32px;
  text-align: left;
  flex-grow: 1;
}

.pricing-features li {
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  color: #090913;
  padding: 6px 0 6px 28px;
  position: relative;
}

.pricing-features li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #14c7b8;
  font-weight: 700;
}

.pricing-cta-button {
  width: 100%;
  background: #0F3B39;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 14px 20px;
  font-weight: 700;
  font-size: 16px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
}

.pricing-cta-button:hover {
  background: #0a2d2b;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(15, 59, 57, 0.4);
}

@media (max-width: 768px) {
  .pricing-section {
    padding: 30px 0 40px 0;
  }

  .pricing-card {
    padding: 28px 24px;
  }

  .pricing-amount {
    font-size: 2.4rem;
  }
}

/* Clients Section */
.clients-section {
  padding: 60px 0 0 0;
  background: white;
}

.clients-content {
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.clients-image {
  width: 100%;
  display: flex;
  justify-content: center;
}

.clients-img {
  width: 80%;
  height: auto;
  max-width: 800px;
  margin-bottom: 20px;
}

.clients-text {
  text-align: center;
  max-width: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
}

.clients-text-content {
  text-align: center;
  width: 100%;
}

.clients-logos {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 40px;
  justify-items: center;
  align-items: center;
  margin-top: 30px;
  width: 100%;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
}

.clients-logos .client-logo:nth-child(7) {
  grid-column: 2;
  grid-row: 3;
  justify-self: center;
}

.client-logo {
  width: 200px;
  height: 120px;
  object-fit: contain;
  transition: transform 1s ease;
  cursor: pointer;
}

.client-logo:hover {
  transform: scale(1.05);
}

/* WhatsApp Button Section */
.whatsapp-section {
  padding: 80px 0 40px 0;
  background: white;
  overflow: visible;
}

.whatsapp-content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 30px 0;
}

.whatsapp-button {
  display: flex;
  align-items: center;
  gap: 15px;
  background: #0F3B39;
  color: white;
  text-decoration: none;
  padding: 25px 60px;
  border-radius: 50px;
  font-weight: bold;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: transform 1s ease, background 1s ease, box-shadow 1s ease;
  box-shadow: none;
  min-width: 300px;
  position: relative;
  z-index: 1;
  cursor: pointer;
}

.whatsapp-button:hover {
  background: #0a2d2b;
  transform: scale(1.05);
  box-shadow: none;
  text-decoration: none;
  color: white;
}

.whatsapp-icon {
  font-size: 24px !important;
}

.whatsapp-text {
  font-weight: bold;
  font-size: 18px;
}

/* Footer */
.footer {
  background: #0F3B39;
  padding: 60px 0 30px 0;
  color: white;
  text-align: center;
}

.footer .container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-logo-section {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  width: 100%;
  order: 1;
}

.footer-logo-section a {
  text-decoration: none;
  display: block;
}

.footer-logo-img {
  height: 80px;
  width: auto;
  filter: brightness(0) invert(1);
}

.footer-info-section {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 80px;
  margin-bottom: 40px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  order: 2;
}

.footer-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
  max-width: 300px;
}

.footer-column-title {
  font-size: 18px;
  font-weight: bold;
  color: white;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.footer-info-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 15px;
  text-align: center;
}

.footer-icon {
    font-size: 20px !important;
  flex-shrink: 0;
    align-self: center;
}

.footer-info-text {
  font-size: 14px;
  line-height: 1.5;
  color: white;
  text-align: center;
}

.footer-social-icons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  text-decoration: none;
}

.social-icon:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
  text-decoration: none;
}

.footer-separator {
  width: 100%;
  max-width: 1200px;
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
  margin: 30px auto;
  display: block;
  order: 3;
}

.footer-copyright {
  text-align: center;
  padding-top: 20px;
  order: 4;
}

.footer-copyright p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
}

/* Large Desktop (1200px and above) */
@media (min-width: 1200px) {
  .container {
    max-width: 1400px;
  }

  .clients-logos {
    gap: 60px;
  }

  .client-logo {
    width: 220px;
    height: 130px;
  }

  .section-title {
    font-size: 2rem;
  }

  .section-description {
    font-size: 1.2rem;
  }
}

/* Responsive Design */
@media (max-width: 768px) {

  /* Hero Section Mobile */

  .hero-banner-container {
    height: 500px;
    overflow: hidden;
  }

  .hero-background {
    object-fit: cover;
    object-position: 60% center;
    width: 100%;
    height: 100%;
  }

  .hero-content {
    flex-direction: column-reverse;
    padding: 10px 2%;
    gap: 0px;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .hero-left {
    max-width: 100%;
    align-items: center;
    text-align: center;
    margin-left: 0;
    flex: none;
    margin-top: -50px;
  }

  .hero-text {
    font-size: 2.8rem;
    text-align: center;
    transform: translateY(30px);
  }

  .hero-check-icon {
    width: 30px;
    height: 30px;
  }

  .hero-right {
    width: 100%;
    max-width: 90%;
    padding: 0;
    text-align: center;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    margin: -30px auto 0 auto;
  }

  .hero-logo {
    max-width: 300px;
  }

  .hero-quest-image {
    width: 110% !important;
    max-width: 110% !important;
    transform: translateY(-50px) scale(1.1);
    min-width: auto;
    height: auto;
  }

  .hero-cards {
    max-width: 400px;
  }

  /* About Section Mobile */
  .about-section {
    padding: 10px 20px 15px 20px;
  }

  .about-content {
    gap: 60px;
  }

  .about-img {
    width: 95%;
  }

  .about-main-image {
    width: 100%;
    max-width: 100%;
    height: 350px !important;
    object-fit: cover;
  }

  .about-text {
    max-width: 95%;
    width: 95%;
    padding: 0 10px;
  }

  .section-title {
    font-size: 2rem;
    margin-bottom: 20px;
  }

  .section-description {
    font-size: 1rem;
    margin-bottom: 15px;
    line-height: 1.6;
  }

  /* Advantages Section Mobile */
  .advantages-section {
    padding: 20px 0 30px 0;
  }

  .advantages-content {
    gap: 15px;
  }

  .advantages-img {
    width: 95%;
    max-width: 700px;
  }

  .advantages-text {
    max-width: 95%;
    width: 95%;
    padding: 0 10px;
  }

  

  .advantage-item {
    gap: 12px;
    padding: 3px 0;
    display: flex;
    align-items: flex-start;
    flex-direction: row;
  }

  .check-icon {
    font-size: 20px !important;
    min-width: 20px;
    height: 20px;
    flex-shrink: 0;
    }

  .advantage-text {
    font-family: 'Montserrat', sans-serif;
    font-size: 1rem;
    color: #090913;
    font-weight: 500;
  }

  /* Clients Section Mobile */
  .clients-section {
    padding: 40px 0 0 0;
  }

  .clients-content {
    gap: 30px;
  }

  .clients-img {
    width: 95%;
    max-width: 700px;
    margin-bottom: 15px;
  }

  .clients-text {
    max-width: 95%;
    width: 95%;
    padding: 0 10px;
  }

  .clients-logos {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
    margin-top: 20px;
    justify-items: center;
    align-items: center;
    justify-content: center;
  }

  .client-logo {
    width: 160px;
    height: 100px;
  }

  /* WhatsApp Button Mobile */
  .whatsapp-section {
    padding: 60px 0 30px 0;
    overflow: visible;
  }

  .whatsapp-content {
    padding: 25px 0;
  }

  .whatsapp-button {
    padding: 18px 35px;
    font-size: 16px;
    min-width: 280px;
    width: 90%;
    max-width: 350px;
    justify-content: center;
  }

  .whatsapp-icon {
    font-size: 20px !important;
  }

  .whatsapp-text {
    font-size: 16px;
  }

  /* Footer Mobile */
  .footer {
    padding: 40px 0 20px 0;
  }

  .footer-logo-section {
    margin-bottom: 30px;
  }

  .footer-logo-img {
    height: 60px;
  }

  .footer-info-section {
    flex-direction: column;
    gap: 30px;
    margin-bottom: 30px;
    padding: 0 20px;
    align-items: center;
  }

  .footer-column {
    align-items: center;
    text-align: center;
    width: 100%;
    max-width: 100%;
  }

  .footer-column-title {
    font-size: 16px;
    margin-bottom: 15px;
  }

  .footer-info-item {
    justify-content: center;
    text-align: center;
    flex-direction: column;
    gap: 8px;
  }

  .footer-info-text {
    font-size: 13px;
  }

  .footer-social-icons {
    justify-content: center;
  }

  .social-icon {
    width: 35px;
    height: 35px;
  }

  .footer-separator {
    margin: 20px auto;
    max-width: 90%;
  }

  .footer-copyright p {
    font-size: 12px;
  }

  /* WhatsApp Floating Button Mobile */
  .whatsapp-floating-button {
    bottom: 20px;
    right: 20px;
    width: 55px;
    height: 55px;
  }

  .whatsapp-floating-icon {
    font-size: 26px !important;
  }
}

/* Tablet Styles (768px to 1024px) */
@media (max-width: 1024px) and (min-width: 769px) {
  .nav-content {
    gap: 80px;
  }
  
  .nav-menu {
    gap: 20px;
  }

  .logo {
    height: 60px;
  }

  .nav-link {
    font-size: 13px;
    padding: 8px 12px;
  }

  .about-img,
  .advantages-img,
  .clients-img {
    width: 85%;
    max-width: 750px;
  }

  .about-text,
  .advantages-text,
  .clients-text {
    max-width: 85%;
    width: 85%;
  }

  .section-title {
    font-size: 2rem;
  }

  .clients-logos {
    gap: 40px;
  }

  .client-logo {
    width: 180px;
    height: 110px;
  }

  .whatsapp-button {
    min-width: 280px;
  }
}


/* Medium Mobile (481px to 768px) */
@media (max-width: 768px) and (min-width: 481px) {



  .clients-logos {
    display: flex;
    flex-direction: row;
    gap: 25px;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .client-logo {
    width: 140px;
    height: 90px;
  }
}

/* Mobile Menu Adjustments */
@media (max-width: 768px) {
  .mobile-nav {
    top: 70px;
  }
}

/* Small Mobile (600px and below) */
@media (max-width: 600px) {
  .hero-banner-container {
    height: 500px;
  }
  
  .hero-background {
    object-position: 65% center;
  }
}

/* Extra Small Mobile (480px and below) */
@media (max-width: 480px) {
  .about-main-image {
    height: 280px !important;
    object-fit: cover;
    margin-bottom: -60px;
  }
  
  .about-section {
    padding: 5px 20px 10px 20px;
  }

  /* Hero Section Extra Small */

  .hero-banner-container {
    height: 500px;
    overflow: hidden;
  }

  .hero-background {
    object-fit: cover;
    object-position: 70% center;
    width: 100%;
    height: 100%;
  }

  .hero-content {
    padding: 10px 5%;
    gap: 0px;
  }

  .hero-text {
    font-size: 2.5rem;
    transform: translateY(0px) !important;
  }

  .hero-check-icon {
    width: 25px;
    height: 25px;
  }

  .hero-logo {
    max-width: 250px;
  }

  .hero-quest-image {
    width: 115% !important;
    max-width: 115% !important;
    transform: translateY(-60px) scale(1.15) !important;
    min-width: auto;
  }

  .hero-cards {
    max-width: 350px;
  }

  .hero-left {
    margin-top: -60px !important;
  }

  .hero-right {
    margin: -40px auto 0 auto !important;
  }

  /* Sections Extra Small */
  .clients-section {
    padding: 30px 0 0 0;
  }

  .about-section {
    padding: 30px 20px 50px 20px;
  }

  .advantages-section {
    padding: 30px 0 50px 0;
  }

  .about-content,
  .advantages-content,
  .clients-content {
    gap: 80px;
  }

  .about-img,
  .advantages-img,
  .clients-img {
    width: 98%;
    max-width: 650px;
  }

  .about-main-image {
    width: 100%;
    max-width: 100%;
  }

  .about-text,
  .advantages-text,
  .clients-text {
    max-width: 98%;
    width: 98%;
    padding: 0 5px;
  }

  .section-title {
    font-size: 1.8rem;
    margin-bottom: 15px;
  }

  .section-description {
    font-size: 0.95rem;
    margin-bottom: 12px;
    line-height: 1.5;
  }

  /* Advantages Extra Small */
  

  .advantage-item {
    gap: 10px;
    padding: 2px 0;
    display: flex;
    align-items: flex-start;
    flex-direction: row;
  }

  .check-icon {
    font-size: 18px !important;
    min-width: 18px;
    height: 18px;
    flex-shrink: 0;
    }

  .advantage-text {
    font-family: 'Montserrat', sans-serif;
    font-size: 0.9rem;
    color: #090913;
    font-weight: 500;
    line-height: 1.4;
  }

  /* Clients Extra Small */
  .clients-logos {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-top: 15px;
    justify-items: center;
    align-items: center;
    justify-content: center;
  }

  .client-logo {
    width: 140px;
    height: 90px;
    padding: 10px;
  }

  /* WhatsApp Button Extra Small */
  .whatsapp-section {
    padding: 50px 0 25px 0;
    overflow: visible;
  }

  .whatsapp-content {
    padding: 20px 0;
  }

  .whatsapp-button {
    padding: 15px 30px;
    font-size: 14px;
    min-width: 260px;
    width: 95%;
    max-width: 320px;
    justify-content: center;
  }

  .whatsapp-icon {
    font-size: 18px !important;
  }

  .whatsapp-text {
    font-size: 14px;
  }

  /* Footer Extra Small */
  .footer {
    padding: 30px 0 15px 0;
  }

  .footer-logo-section {
    margin-bottom: 25px;
  }

  .footer-logo-img {
    height: 50px;
  }

  .footer-info-section {
    gap: 25px;
    margin-bottom: 25px;
    padding: 0 15px;
    align-items: center;
  }

  .footer-column-title {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .footer-info-text {
    font-size: 12px;
  }

  .social-icon {
    width: 30px;
    height: 30px;
  }

  .footer-separator {
    margin: 15px auto;
    max-width: 90%;
  }

  .footer-copyright p {
    font-size: 11px;
  }

  /* WhatsApp Floating Button Extra Small */
  .whatsapp-floating-button {
    bottom: 15px;
    right: 15px;
    width: 50px;
    height: 50px;
  }

  .whatsapp-floating-icon {
    font-size: 24px !important;
  }
}

/* Mobile Menu Position Fix */
@media (max-width: 480px) {
  .mobile-nav {
    top: 60px;
  }
}

/* Animations */
@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes bounceInUp {
  0% {
    opacity: 0;
    transform: translateY(50px) scale(0.8);
  }
  50% {
    opacity: 0.8;
    transform: translateY(-10px) scale(1.05);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Animation Classes */
.animate-ready {
  opacity: 0;
}

.animate-fadeInUp {
  animation: fadeInUp 0.8s ease-out forwards;
}

.animate-fadeInLeft {
  animation: fadeInLeft 0.8s ease-out forwards;
}

.animate-fadeInRight {
  animation: fadeInRight 0.8s ease-out forwards;
}

.animate-bounceInUp {
  animation: bounceInUp 1s ease-out forwards;
}

/* Força o hover do botão WhatsApp */
.whatsapp-section .whatsapp-content .whatsapp-button {
  transition: transform 1s ease, background 1s ease, box-shadow 1s ease !important;
}

.whatsapp-section .whatsapp-content .whatsapp-button:hover {
  background: #0a2d2b !important;
  transform: scale(1.05) !important;
  box-shadow: none !important;
  text-decoration: none !important;
  color: white !important;
}

/* Regra adicional para garantir funcionamento */
a.whatsapp-button {
  transition: transform 1s ease, background 1s ease, box-shadow 1s ease !important;
}

a.whatsapp-button:hover {
  background: #0a2d2b !important;
  transform: scale(1.05) !important;
  box-shadow: none !important;
  text-decoration: none !important;
  color: white !important;
}

/* Força o hover dos logos dos clientes */
.clients-section .clients-text .clients-logos .client-logo {
  transition: transform 1s ease !important;
  cursor: pointer !important;
}

.clients-section .clients-text .clients-logos .client-logo:hover {
  transform: scale(1.05) !important;
}

/* Regra adicional para imagens dos logos */
img.client-logo {
  transition: transform 1s ease !important;
  cursor: pointer !important;
}

img.client-logo:hover {
  transform: scale(1.05) !important;
}

/* WhatsApp Floating Button */
.whatsapp-floating-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  background: #25D366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  z-index: 1000;
  transition: all 0.3s ease;
  text-decoration: none;
  animation: pulse 2s infinite;
}

.whatsapp-floating-button:hover {
  background: #20BA5A;
  transform: scale(1.1);
  box-shadow: none;
  text-decoration: none;
}

.whatsapp-floating-icon {
  font-size: 30px !important;
  color: white !important;
}

/* Pulse Animation */
@keyframes pulse {
  0% {
    box-shadow: none;
  }
  50% {
    box-shadow: none;
  }
  100% {
    box-shadow: none;
  }
}
</style>
